<div class="retention-timeline">
  <div class="chart">
    <div
      class="marker-label soft-delete"
      [class.align-end]="isNearEnd(view.softDeletionDate)"
      [class.align-start]="isNearStart(view.softDeletionDate)"
      [style.left.%]="percentageFor(view.softDeletionDate)"
    >
      <span class="name" translate="CALLS.EXTEND_RETENTION.TIMELINE_SOFT_DELETE"></span>
      <span class="date">{{ view.softDeletionDate | date: dateFormat }}</span>
    </div>

    @if (view.maximumSoftDeletionDate !== null) {
      <div
        class="tick max-soft-delete"
        [class.align-end]="isNearEnd(view.maximumSoftDeletionDate)"
        [class.align-start]="isNearStart(view.maximumSoftDeletionDate)"
        [style.left.%]="percentageFor(view.maximumSoftDeletionDate)"
      >
        <span class="caption"
          >{{ 'CALLS.EXTEND_RETENTION.TIMELINE_MAXIMUM_SOFT_DELETE' | translate }} · {{ view.maximumSoftDeletionDate | date: dateFormat }}</span
        >
        <span class="line"></span>
      </div>
    }

    <div class="track" #track>
      <span class="segment retained" [style.width.%]="percentageFor(view.softDeletionDate)"></span>
      <span class="segment recoverable" [style.left.%]="percentageFor(view.softDeletionDate)" [style.width.%]="recoverableWidthPercentage"></span>
      <span class="dot meeting"></span>
      <span class="dot hard-delete" [style.left.%]="percentageFor(view.deletionDate)"></span>
      <span
        class="dot soft-delete"
        role="slider"
        tabindex="0"
        [attr.aria-label]="'CALLS.EXTEND_RETENTION.TIMELINE_SLIDER_LABEL' | translate"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="view.maximumExtensionInDays"
        [attr.aria-valuenow]="view.extensionInDays"
        [attr.aria-valuetext]="view.softDeletionDate | date: dateFormat"
        [style.left.%]="percentageFor(view.softDeletionDate)"
        (pointerdown)="startDragging($event)"
        (pointermove)="continueDragging($event)"
        (pointerup)="stopDragging()"
        (pointercancel)="stopDragging()"
        (keydown)="handleKeyDown($event)"
      ></span>
    </div>

    <div class="marker-label meeting">
      <span class="name" translate="CALLS.EXTEND_RETENTION.TIMELINE_CALL"></span>
      <span class="date">{{ view.meetingDate | date: dateFormat }}</span>
    </div>
    <div
      class="marker-label hard-delete"
      [class.align-end]="isNearEnd(view.deletionDate)"
      [class.align-start]="isNearStart(view.deletionDate)"
      [style.left.%]="percentageFor(view.deletionDate)"
    >
      <span class="name" translate="CALLS.EXTEND_RETENTION.TIMELINE_HARD_DELETE"></span>
      <span class="date">{{ view.deletionDate | date: dateFormat }}</span>
    </div>

    <div
      class="tick original-soft-delete"
      [class.align-end]="isNearEnd(view.originalSoftDeletionDate)"
      [class.align-start]="isNearStart(view.originalSoftDeletionDate)"
      [style.left.%]="percentageFor(view.originalSoftDeletionDate)"
    >
      <span class="line"></span>
      <span class="caption"
        >{{ 'CALLS.EXTEND_RETENTION.TIMELINE_ORIGINAL_SOFT_DELETE' | translate }} · {{ view.originalSoftDeletionDate | date: dateFormat }}</span
      >
    </div>

    <div
      class="tick original-hard-delete"
      [class.align-end]="isNearEnd(view.originalDeletionDate)"
      [class.align-start]="isNearStart(view.originalDeletionDate)"
      [style.left.%]="percentageFor(view.originalDeletionDate)"
    >
      <span class="line"></span>
      <span class="caption">{{ 'CALLS.EXTEND_RETENTION.TIMELINE_ORIGINAL_HARD_DELETE' | translate }} · {{ view.originalDeletionDate | date: dateFormat }}</span>
    </div>

    @if (view.maximumDeletionDate !== null) {
      <div
        class="tick max-hard-delete"
        [class.align-end]="isNearEnd(view.maximumDeletionDate)"
        [class.align-start]="isNearStart(view.maximumDeletionDate)"
        [style.left.%]="percentageFor(view.maximumDeletionDate)"
      >
        <span class="line"></span>
        <span class="caption">{{ 'CALLS.EXTEND_RETENTION.TIMELINE_MAXIMUM_HARD_DELETE' | translate }} · {{ view.maximumDeletionDate | date: dateFormat }}</span>
      </div>
    }
  </div>

  <div class="summary">
    <span class="extended">
      <span translate="CALLS.EXTEND_RETENTION.TIMELINE_EXTENDED_BY"></span>
      <span class="value">{{ extendedByLabel }}</span>
    </span>
    <span class="recovery-window">
      <span translate="CALLS.EXTEND_RETENTION.TIMELINE_RECOVERY_WINDOW"></span>
      <span class="value">{{ recoveryWindowLabel }}</span>
    </span>
  </div>
</div>
